import React from 'react';

const PanicCard = ({ title, value }) => {
    return (
        <div className='flex flex-col flex-grow xl:w-48 p-5 items-center justify-center rounded-lg bg-white space-y-5'>
            <h2 className='text-xs md:text-sm font-medium'>{title}</h2>
            <p className='text-lg md:text-2xl font-semibold'>{value}</p>
        </div>
    );
};

export default PanicCard;
